<template>
  <div class="link-list">
    <router-link class="link-item" :to="toUrl">
      <el-row style="width: 100%;height: 100%">
        <el-col :span="4" class="icon">
          <img :src="src"/>
        </el-col>
        <el-col :span="16" class="text">
          <div class="menu-text">{{text}}</div>
        </el-col>
        <el-col :span="4" class="more">
          <i class="el-icon-arrow-right" style="font-weight: 800"></i>
        </el-col>
      </el-row>
    </router-link>
  </div>
</template>

<script>
    export default {
        props:{
          toUrl:{
            type:String,
            default:''
          },
          src:{
            type:String,
            default:''
          },
          text:{
            type:String,
            default:''
          }
        }
    }
</script>

<style scoped>
 .link-list{
   width: 100%;
   height: .9rem;
   border-bottom: 1px #dddddd solid;
 }
 .link-item{
   width: 100%;
   height: 100%;
}
 .icon{
   line-height: .6rem;
   padding-left: .4rem;
   color: #333333;
 }

 .icon img{
   width: .5rem;
   height: .5rem;
 }
 .text{
   line-height: .9rem;
   font-size: .28rem;
   color: #000;
 }
 .menu-text{
   text-overflow:ellipsis;
   overflow:hidden;
   white-space: nowrap;
 }
 .more{
   line-height: .9rem;
   font-size: .36rem;
   padding-right: .2rem;
   color: #8a8a8a;
   text-align: right;
 }
</style>



// WEBPACK FOOTER //
// src/components/common/Menu.vue